<div class="header">
  <div class="object-name">
    {{ attributes.id }}
  </div>
  @if (attributes.isClosed) {
    <div class="sub-header">
      <span class="closed">This runway is currently closed</span>
    </div>
  }
</div>
<div class="info-container">
  @if (attributes.magneticBearing) {
    <div class="info">
      <p class="field-title">Magnetic Bearing</p>
      {{ attributes.magneticBearing }}
    </div>
  }
  @if (attributes.touchdownZoneElevation) {
    <div class="info">
      <p class="field-title">Touchdown Zone Elevation</p>
      {{ attributes.touchdownZoneElevation }}
    </div>
  }
  @if (attributes.surfaceMaterial) {
    <div class="info">
      <p class="field-title">Surface Material</p>
      {{ attributes.surfaceMaterial }}
    </div>
  }
  @if (attributes.length) {
    <div class="info">
      <p class="field-title">Length</p>
      {{ attributes.length }}
    </div>
  }
  @if (attributes.width) {
    <div class="info">
      <p class="field-title">width</p>
      {{ attributes.width }}
    </div>
  }
  @if (attributes.lightPosition) {
    <div class="info">
      <p class="field-title">Light Position</p>
      {{ attributes.lightPosition }}
    </div>
  }
  @if (attributes.airportId) {
    <div class="info">
      <p class="field-title">Airport ID</p>
      {{ attributes.airportId }}
    </div>
  }
</div>
